export default {
  integrations (state) {
    return state.integrations
  },
  integration (state) {
    return state.integration
  },
  providers (state) {
    return state.providers
  },
  availableFields (state) {
    return state.availableFields
  },
  syncLogs (state) {
    return state.syncLogs
  }
}
